module.exports = __webpack_public_path__ + "img/room.68e3ef50.png";